import * as PropTypes from 'prop-types';
import * as React from 'react';
import AddressFields from '../addresses/address_fields';
import UrlHelpers from '../shared/url_helpers';
import { APIRequest } from '@reverbdotcom/discovery-ui';

class ShippingLabelEditAddressForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countriesForSelect: [],
    };
  }

  componentDidMount() {
    this.fetchCountriesForSelect();
  }

  fetchCountriesForSelect() {
    APIRequest.V3.get(UrlHelpers.countriesPath).done((response) => {
      this.setState({
        countriesForSelect: response.countries,
      });
    });
  }

  render() {
    return (
      <AddressFields
        name={this.props.name}
        streetAddress={this.props.streetAddress}
        extendedAddress={this.props.extendedAddress}
        locality={this.props.locality}
        region={this.props.region}
        postalCode={this.props.postalCode}
        countryCode={this.props.countryCode}
        phone={this.props.phone}
        countriesForSelect={this.state.countriesForSelect}
        nameForInput={fieldName => this.props.nameForInput(fieldName)}
        includePhoneInput={this.props.includePhoneInput}
        phoneInputRequired={this.props.phoneInputRequired}
        includeSaveButton={false}
        includeNameInput
        addressTitle={I18n.t('js.addresses.addressForm.address')}
      />
    );
  }
}

ShippingLabelEditAddressForm.propTypes = {
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  nameForInput: PropTypes.func.isRequired,
  includePhoneInput: PropTypes.bool.isRequired,
  phoneInputRequired: PropTypes.bool.isRequired,
};

ShippingLabelEditAddressForm.defaultProps = {
  phoneInputRequired: true,
};

export default ShippingLabelEditAddressForm;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/edit_address_form.jsx